import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { EndpointService } from '@app/core';

@Injectable()
export class TitlePreviewDataSercice {

  constructor(private http: HttpClient, private toastr: ToastrService, private api: EndpointService) { }

  /**
   * Metodo que permite eliminar un Tramite
   *
   * @param {number} id
   * @return {*}  {Promise<boolean>}
   * @memberof TitlePreviewDataSercice
   */
  deleteProcess(id: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.skipErrorHandler().delete<boolean>(this.api.get('removeLiquidation', [id])).subscribe(
        resp => {
          this.toastr.success('Operación exitosa', 'Tramite eliminado correctamente');
          resolve(true);
        },
        err => {
          if (err.status === 400) {
            if (err.error) {
              this.toastr.warning('Error al ejecutar operacion', err.error);
            } else if (err.error.detail) {
              this.toastr.warning('Error al ejecutar operacion', err.error.detail);
            }
          } else if (err.status !== 401 && err.status !== 403) {
            this.toastr.error('Fallo del sistema', 'Error de operacion');
          }
          reject(err);
        }
      );
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/title-preview/shared/title-preview.data.service.ts